// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zZZj","right":"Footer_right__rOGtt","buttons":"Footer_buttons__2mlFw"};